export const environment = {
  production: true,
  persona: false,
};
